import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// Reads the OS-level motion preference once and keeps following it, so a
// visitor who flips the setting doesn't have to reload.
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
};

export const usePrefersReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReducedMotion);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia(QUERY);
    const onChange = (event) => setReduced(event.matches);

    // Safari < 14 only supports the deprecated listener API.
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', onChange);
      return () => mediaQuery.removeEventListener('change', onChange);
    }
    mediaQuery.addListener(onChange);
    return () => mediaQuery.removeListener(onChange);
  }, []);

  return reduced;
};

export default usePrefersReducedMotion;
